module.exports = __webpack_public_path__ + "img/publication.67362aef.svg";